import {Navigate} from "react-router-dom";
import PropTypes from "prop-types";
import {useAuth} from "../context/AuthContext";
import {useLanguage} from "../context/LanguageContext";

export default function ProtectedRoute({children, requiredRole}) {
    const {user, isLoading} = useAuth();
    const {t} = useLanguage();

    if (isLoading) {
        return <div>{t("common.loading")}</div>;
    }

    if (!user) {
        return <Navigate to="/" replace/>;
    }

    // Si se especifica un rol requerido, verificar que coincida
    if (requiredRole && user.rol !== requiredRole) {
        return <Navigate to="/" replace/>;
    }

    // Verificación adicional para niños
    if (user.rol === 'child') {
        const storedChild = localStorage.getItem("childUser");
        if (!storedChild) {
            return <Navigate to="/" replace/>;
        }
    }

    // Verificación adicional para adultos
    if (user.rol === 'adult') {
        const storedAdult = localStorage.getItem("adultUser");
        if (!storedAdult) {
            return <Navigate to="/" replace/>;
        }
    }

    // Verificación adicional para admins
    if (user.rol === 'admin') {
        const storedAdult = localStorage.getItem("adultUser");
        if (!storedAdult) {
            return <Navigate to="/" replace/>;
        }
    }

    return children;
}

ProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired,
    requiredRole: PropTypes.oneOf(['child', 'adult', 'admin']),
};
